<template>
    <div id="fileAccessEditRulePanel" class="form-wrapper">

        <PanelDropdown v-model="folderMap" :label="$t('folderMap')" :options="folderOptions" placeholder="None"
            :formType="formType" :tooltip="tooltips.shared.folderMap" />
        <FolderFileName v-model="localForm.fileName" :max-length="256" :label="$t('folderFileName')" :tooltip="tooltips.shared.folderFileName" />
        <PanelDropdown v-model="localForm.accessControl" :label="$t('accessControl')" :options="accessControlOptions"
            placeholder="None" :formType="formType" :tooltip="tooltips.fileAccess.accessControl" style="padding-top: 10px;"/>

        <div class="d-flex">
            <div class="d-flex col-5">
                <label class="form-label ">{{ $t('auditCreateOperations') }} </label>
                <Tooltip :text="tooltips.fileAccess.auditCreateOperations"><i
                        class="ag-icon ag-icon_table_info small info-icon"></i></Tooltip>

            </div>

            <div class="col-7">
                <ToggleSwitch v-model="localForm.auditCreateOperations" label="" :show-info="false" />
            </div>
        </div>
        <ExpertNotes v-model="localForm.expertNotes" :max-length="1000" :label="$t('notes')" />

    </div>
</template>

<script setup>
import { defineProps, ref, watch, defineEmits, computed } from 'vue'
import ToggleSwitch from './components/toggle-switch.vue'
import PanelInput from './components/panelInput.vue'
import PanelDropdown from './components/panelDropdown.vue'
import ExpertNotes from './components/expertNotes.vue';
import { useStore } from "@/store";
import tooltips from '@/assets/tooltips/en.json'
import Tooltip from './components/tooltip.vue'
import FolderFileName from './components/folderFileName.vue';
const store = useStore();
const props = defineProps({
    form: {
        type: Object,
        required: true,
    },
    formType: {
        type: String,
        default: 'fileAccess'
    },
    enumKey: {
        type: String,
        default: 'AccessControl'
    },
});



const folderOptions = computed(() => {
    const original = store.state.general.folderMaps || [];
    return [{ label: "None", value: null }, { label: "Any", value: -1 }, ...original];
});
const accessControlOptions = computed(() => {
    return store.state.general.enums[props.enumKey] || [];
});

const emit = defineEmits(['update:form'])
const localForm = computed({
    get() {
        return props.form;
    },
    set(newVal) {
        emit('update:form', newVal);
    }
});

const folderMap = computed({
    get() {
        return localForm.value.isFolderMapIdAny ? -1 : localForm.value.folderMapId;
    },
    set(val) {
        if (val === -1) {
            localForm.value.isFolderMapIdAny = true;
            localForm.value.folderMapId = -1;
        } else if (val === null) {
            localForm.value.isFolderMapIdAny = false;
            localForm.value.folderMapId = null;
        } else {
            localForm.value.isFolderMapIdAny = false;
            localForm.value.folderMapId = val;
        }
    },
});

</script>
<style>
.form-wrapper {
    font-size: 0.8rem !important;
}

.custom-input {
    width: inherit;
}

.boxed-group {
    width: inherit;
    border: 1px solid #dcdcdc;
    border-radius: 6px;
    padding: 12px;
    margin-right: 10px;

}

.label-check {
    margin-left: 5px;
    margin-bottom: 0px !important;
}

.form-label {
    color: #164B6C;
    font-weight: bold;
    margin-left: 8px;
}

.info-icon {
    margin-left: 6px;
    display: inline-flex;
    align-items: center;
}
</style>
